module.exports = __webpack_public_path__ + "cc03679d25f5d39137f8fa10cd40d422.svg";